import { useEffect, useState } from "react";
import { Provider as StoreProvider } from "react-redux";
import store, { persistor } from "./lib/store";
import { PersistGate } from "redux-persist/integration/react";

const Provider = ({ children }) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return <StoreProvider store={store}>{children}</StoreProvider>;
    } else {
        return (
            <StoreProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    {children}
                </PersistGate>
            </StoreProvider>
        );
    }
};

export default Provider;
